import { Injectable } from '@angular/core';
import { AIFileType } from '@edtech-ui/constants/file-type.enum';
import { AIValidatedFile } from '@edtech-ui/core/models/ai-course/ai-file';
@Injectable({
	providedIn: 'root'
})
export class FileValidationService {

	private readonly allowedTypes = [
		'application/pdf',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		'text/plain'
	];

	private readonly allowedTypesCourse: Record<string, AIFileType> = {
		'application/pdf': AIFileType.PDF,
		'application/x-pdf': AIFileType.PDF,
		'application/octet-stream': AIFileType.PDF,
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': AIFileType.DOCX,
		'text/plain': AIFileType.TXT,
	};

	private readonly allowedTypesMaterial: Record<string, AIFileType> = {
		'application/pdf': AIFileType.PDF,
		'application/x-pdf': AIFileType.PDF,
		'application/octet-stream': AIFileType.PDF,
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': AIFileType.DOCX,
		'text/plain': AIFileType.TXT,
		'image/jpeg': AIFileType.IMAGE,
		'image/jpg': AIFileType.IMAGE,
		'image/png': AIFileType.IMAGE,
		'image/webp': AIFileType.IMAGE,
		'image/json': AIFileType.JSON,
		'video/mp4': AIFileType.VIDEO,
		'video/mpeg': AIFileType.VIDEO,
		'video/quicktime': AIFileType.VIDEO,
		'audio/mpeg': AIFileType.AUDIO,
		'audio/wav': AIFileType.AUDIO,
		'application/json': AIFileType.JSON,
	};

	private readonly maxSize = 2 * 1024 * 1024;
	private readonly maxCourseSize = 10 * 1024 * 1024;
	private readonly maxMaterialSize = 10 * 1024 * 1024;

	validateFile(file: File): string | null {
		if (!this.allowedTypes.includes(file.type)) {
			return 'Only PDF, DOCX, or TXT files are allowed.';
		}
		if (file.size > this.maxSize) {
			return 'File size should not exceed 2 MB.';
		}
		return null;
	}

	processFile(file: File): { fileData?: AIValidatedFile; error?: string } {
		if (!(file.type in this.allowedTypesCourse)) {

			return { error: 'Only PDF, DOCX, or TXT files are allowed.' };
		}
		if (file.size > this.maxCourseSize) {
			return { error: 'File size should not exceed 10 MB.' };
		}

		const mappedType = this.allowedTypesCourse[file.type];
		const fileData: AIValidatedFile = {
			file,
			type: mappedType,
			...(mappedType === AIFileType.TXT ? { content: '' } : {})
		};
		return { fileData };
	}

	processFileMaterial(file: File): { fileData?: AIValidatedFile; error?: string } {
		if (!(file.type in this.allowedTypesMaterial)) {
			return { error: 'Only JPG, JPEG, PNG, WEBP, JSON, PDF, DOCX,images, videos, audio, or TXT files are allowed.' };
		}
		if (file.size > this.maxMaterialSize) {
			return { error: 'File size should not exceed 10 MB.' };
		}

		const mappedType = this.allowedTypesMaterial[file.type];
		const fileData: AIValidatedFile = {
			file,
			type: mappedType,
			...(mappedType === AIFileType.TXT ? { content: '' } : {})
		};
		return { fileData };
	}

}